<template>
  <div class="page">
    <div class="login-wrapper">
      <div class="login-content">
        <div class="site-logo">
          <img src="../../assets/images/logo-trans.png" />
        </div>
        <div class="site-text">
          <div class="main">精进卓越&nbsp;&nbsp;赋能增长</div>
          <div class="sub">欢迎使用百威中国售点物料一站式服务平台</div>
        </div>
        <div class="sso-info"
          v-show="loading"
          v-loading="loading"
          element-loading-text="正在初始化登录信息..."
          element-loading-background="rgba(0, 0, 0, 0.1)"
          element-loading-spinner="el-icon-loading"
          element-loading-custom-class="loadingText">
        </div>
      </div>
    </div>
    <Footer :show-help="false"/>
  </div>
</template>

<script>
import Footer from '../layout/components/footer'
import authApi from '@/api/auth'
export default {
  name: 'sso-endpoint',
  components: {
    Footer
  },
  data () {
    return {
      loading: false
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      const errorCode = this.$route.query.errorCode || ''
      const errorMsg = this.$route.query.errorMsg || ''
      console.log(errorCode)
      console.log(errorMsg)
      if (errorCode !== '') {
        this.$alert('登录请求错误, 错误原因: ' + errorMsg, {
          callback: action => {
            this.$router.push('/login')
          }
        })
      } else {
        this.getLoginData()
      }
    },
    getLoginData () {
      this.loading = true

      const userToken = this.$route.query.userToken
      const expireTime = this.$route.query.expireTime
      const target = this.$route.query.target
      // console.log(userToken)
      // console.log(expireTime)
      // console.log(target)
      const params = {
        userToken: userToken,
        expireTime: expireTime
      }
      authApi.ssoInitClient(params).then(response => {
        // console.log(response.data)
        this.loading = false
        if (response.data.resultCode === '0') {
          this.$store.commit('SET_USER_INFO', response.data.resultData)
          this.$router.push(target)
        } else {
          this.$alert('登录信息初始化失败, 错误原因: ' + response.data.resultMsg, {
            callback: action => {
              this.$router.push('/login')
            }
          })
        }
      }).catch(() => {
        this.loading = false
        this.$alert('统一认证服务异常', {
          callback: action => {
            this.$router.push('/login')
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
}
.login-wrapper {
  height: calc(100% - 100px);
  width: 100%;
  color: $base-white;
  box-sizing: border-box;
  background: url("../../assets/images/login-bg.jpg") center no-repeat;
  background-size: cover;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  .site-logo {
    width: 166px;
    height: 84px;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .site-text {
    margin: 60px 0 100px 0;
    .main {
      font-weight: 700;
      font-size: 50px;
      margin-bottom: 15px;
    }
    .sub {
      font-size: 18px;
    }
  }
  .sso-info {
    margin: 30px auto;
    padding: 10px;
    width: 400px;
    height: 80px;
    color: #111;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 5px;

    ::v-deep .el-icon-loading {
      color: $base-red;
    }
    ::v-deep .el-loading-text {
      color: $base-red;
    }
  }

}
</style>
